import request from '@/utils/request';

export function getGames (filter) {
  return request.get('api/admin/games', filter);
}

export function getGamesAll () {
  return request.get('api/admin/gameall')
}

export function saveGame (app) {
  return request.post('/api/admin/games', app);
}

export function updateGame (app) {
  return request.put('/api/admin/games/', app);
}

export function deleteGame (id) {
  return request.delete('/api/admin/games/', id);
}



// WEBPACK FOOTER //
// ./src/api/games.js